import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, ModelSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { IPHXOutputComponent } from '../../../../@core/interfaces/IPHXOutputComponent.interface';
import { Task } from '../../../../generated/generated-types';
import { PhxAvatarComponent } from '../../../../shared/components/phx-avatar/phx-avatar.component';
import { TaskService } from '../../services/task.service';

@Component({
    selector: 'app-task-status-column-widget',
    templateUrl: './task-status-column-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [PhxAvatarComponent, CommonModule, TooltipModule, TranslatePipe, CheckboxModule, FormsModule]
})
export class TaskStatusColumnWidgetComponent implements IPHXOutputComponent {

    model: Task;
    modelSig?: ModelSignal<Task>;
    args: any;
    change = new EventEmitter<any>();

    private taskService = inject(TaskService);

    get task(): Task | null {
        return this.modelSig ? this.modelSig() : this.model;
    }

    isCompleted = computed(() => {
        return this.task?.status === 'COMPLETED';
    });

    isOverdue = computed(() => {
        const task = this.task;
        if (!task?.dueDate || task.status === 'COMPLETED') {
            return false;
        }

        const today = new Date();
        const dueDate = new Date(task.dueDate);

        // Set time to start of day for proper comparison
        today.setHours(0, 0, 0, 0);
        dueDate.setHours(0, 0, 0, 0);

        return dueDate < today;
    });

    async onCheckboxChange(checked: boolean) {
        const task = this.task;
        if (!task?.id) {
            return;
        }

        try {
            if (checked) {
                await this.taskService.markAsCompleted(task.id);
            } else {
                await this.taskService.markAsInProgress(task.id);
            }

            // Emit change event to trigger refresh
            this.change.emit({ value: checked, property: 'status' });
        } catch (error: any) {
            console.error('Error toggling task completion:', error);
        }
    }

}

